export default __webpack_public_path__ + "images/8bb7d2508e1369c8e08b3da2c21bf55f-Barlow-Bold.woff2";